import { buildModelsActionCreator } from 'epics/model/actions';
import type { ErrorResponse } from 'epics/model/types';

export interface RestUiModificationsData {
	uiModifications: {
		appEnvId: string;
		uiModifications: {
			id: string;
			data: unknown;
		}[];
	}[];
	forge: {
		uiModificationsExtensions: {
			id: string;
			appVersion: string;
			installationId: string;
			environmentId: string;
			environmentType: string;
			environmentKey: string;
			license: unknown;
			properties: Record<string, unknown>;
			scopes: string[];
			type: string;
			egress: unknown[];
			installationConfig: unknown;
			consentUrl: string;
			userAccess: {
				hasAccess: boolean;
				enabled?: boolean;
			};
			hiddenBy: unknown;
		}[];
	};
}

export interface UiModificationsResponse extends RestUiModificationsData {
	error?: {
		code: string;
		message: string;
	};
}

export const FETCH_UI_MODIFICATIONS_MODEL = 'epic.model.FETCH_UI_MODIFICATIONS_MODEL';
export const FETCH_UI_MODIFICATIONS_SUCCESS =
	'state.persisted.uiModifications.FETCH_UI_MODIFICATIONS_SUCCESS';
export const FETCH_UI_MODIFICATIONS_FAILURE =
	'state.persisted.uiModifications.FETCH_UI_MODIFICATIONS_FAILURE';

export type FetchUiModificationsAction = ReturnType<typeof fetchUiModificationsAction>;

export const fetchUiModificationsAction = buildModelsActionCreator(
	FETCH_UI_MODIFICATIONS_MODEL,
	'uiModifications',
);

export interface FetchUiModificationsSuccess {
	type: typeof FETCH_UI_MODIFICATIONS_SUCCESS;
	payload: {
		portalId: number;
		requestTypeId: number;
		uiModifications: RestUiModificationsData;
	};
}

export const fetchUiModificationsSuccess = (
	portalId: number,
	requestTypeId: number,
	uiModifications: RestUiModificationsData,
): FetchUiModificationsSuccess => ({
	type: FETCH_UI_MODIFICATIONS_SUCCESS,
	payload: {
		portalId,
		requestTypeId,
		uiModifications,
	},
});

export interface FetchUiModificationsFailure {
	type: typeof FETCH_UI_MODIFICATIONS_FAILURE;
	payload: {
		portalId: number;
		requestTypeId: number;
		error: ErrorResponse;
	};
}

export const fetchUiModificationsFailure = (
	portalId: number,
	requestTypeId: number,
	error: ErrorResponse,
): FetchUiModificationsFailure => ({
	type: FETCH_UI_MODIFICATIONS_FAILURE,
	payload: {
		portalId,
		requestTypeId,
		error,
	},
});
